import { schema } from 'normalizr';

export const channel = new schema.Entity('channels');

export const discussion = new schema.Entity('discussions');

export const comment = new schema.Entity('comments');

channel.define({
  discussions: [discussion],
});

discussion.define({
  channel,
  comments: [comment],
});

comment.define({
  discussion,
  quotedComment: comment,
  replies: [comment],
});
